// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { Capacitor } from '@capacitor/core';

// Utils
import platformSingleton from '../../platform/platformSingleton';
import { isPlatformIframe } from '../../platform/utils/platformDetailsUtils';
import { LifecyclePlugin } from '../../../capacitor_plugins/lifecycle';

// Constants
import { CAPACITOR_LIFECYCLE_PLUGIN } from '../../../capacitor_plugins/pluginConstants';

export default (DecoratedComponent) => {
    class WorkspacePageLoadingStateDecorator extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                showLoader: true,
            };
        }

        componentDidMount() {
            // for hot reloading
            if (this.props.isUserAvailable && !this.props.isGuest && this.props.currentBoardId) this.finishLoading();
        }

        componentWillReceiveProps(nextProps) {
            // If the loader is already hidden we don't need to finish loading again
            if (!this.state.showLoader) return;

            if (
                (nextProps.isUserAvailable &&
                    nextProps.currentBoard &&
                    (nextProps.isGuest || nextProps.socketConnected || isPlatformIframe(platformSingleton)) &&
                    nextProps.isCurrentBoardFetched) ||
                (nextProps.isUserAvailable && nextProps.isCurrentBoardError)
            ) {
                this.finishLoading();
            }
        }

        finishLoading = () => {
            this.setState({ showLoader: false });
            if (Capacitor.isPluginAvailable(CAPACITOR_LIFECYCLE_PLUGIN)) {
                LifecyclePlugin.webDidLoad();
            }
        };

        render() {
            const { showLoader } = this.state;
            return <DecoratedComponent {...this.props} showLoader={showLoader} />;
        }
    }

    WorkspacePageLoadingStateDecorator.propTypes = {
        isUserAvailable: PropTypes.bool,
        isGuest: PropTypes.bool,
        isCurrentBoardFetched: PropTypes.bool,
        isCurrentBoardError: PropTypes.bool,
        socketConnected: PropTypes.bool,
        currentBoard: PropTypes.object,
        currentBoardId: PropTypes.string,
    };

    return WorkspacePageLoadingStateDecorator;
};
